export const ENTITY_PAGE_PROFILE_LAYOUT_WIDGETS_EXPAND_INITIAL_STATE = {
  collapsedWidgetsCount: 0,
  expandCommand: null,
  expandedWidgetsCount: 0,
}

export const ENTITY_PAGE_PROFILE_LAYOUT_TOGGLED_WIDGETS_COUNT = 1
